import { useEffect, useState } from "react";

const API = process.env.REACT_APP_BACKEND_URL;

/**
 * Hook to fetch active ads for a given placement.
 * Returns { ads, loading }. Re-fetches every 5 minutes to pick up admin changes.
 */
export function useAds(placement) {
  const [ads, setAds] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let alive = true;
    let timer = null;
    const fetchOnce = async () => {
      try {
        const r = await fetch(`${API}/api/ads/active?placement=${encodeURIComponent(placement)}`);
        const j = await r.json();
        if (alive) setAds(j.items || []);
      } catch {
        if (alive) setAds([]);
      } finally {
        if (alive) setLoading(false);
      }
    };
    fetchOnce();
    timer = setInterval(fetchOnce, 5 * 60 * 1000);
    return () => { alive = false; if (timer) clearInterval(timer); };
  }, [placement]);

  return { ads, loading };
}
